import {PermissionsBuilder} from '../../commons/data-services/permissions.builder';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type UserService from '../../user/user.service';
import type {PermissionResponse, PermissionsDataService} from '../../commons/data-services/permissions.data-service';
import type LoanService from '../../commons/services/loan.service';
import type WalkerService from '../../commons/services/walker.service';
import type ModalConversationInterceptorService from '../../commons/services/modal-conversation-interceptor.service';
import {LoanInterceptorRegistrar} from '../../loan/loan.interceptor-registrar';
import type {LocalizationService} from '../../commons/providers/localization.provider';
import {UserInterceptorRegistrar} from '../../user/user.interceptor-registrar';

export default class UsersController {

    public static getUserPermissions(cachedPermissionsDataService: PermissionsDataService): Promise<PermissionResponse> {
        const permissions = new PermissionsBuilder()
            .addPermission('LoanReturnAny')
            .addPermission('UserCreate')
            .addPermission('SoftwareUserCreate')
            .addPermission('PaymentsPrint')
            .build();
        return cachedPermissionsDataService.canDoActions(permissions);
    }

    /*@ngInject*/
    constructor(private walker: WalkerService,
                private userService: UserService,
                private loanService: LoanService,
                public permissions: PermissionResponse,
                private modalConversationInterceptor: ModalConversationInterceptorService,
                private localizationService: LocalizationService) {
        new LoanInterceptorRegistrar(this.modalConversationInterceptor, this.localizationService).register();
        new UserInterceptorRegistrar(this.modalConversationInterceptor).register();
    }

    @ngAsync()
    public async showReturningForm() {
        await this.loanService.showReturningForm();
    }

    @ngAsync()
    public async createNewPersonReader() {
        return this.userService.createNewPersonReader();
    }

    @ngAsync()
    public async createNewEditorPerson() {
        return this.userService.createNewEditorPerson();
    }

    @ngAsync()
    public async createNewLibraryReader() {
        return this.userService.createNewLibraryReader();
    }

    @ngAsync()
    public async createNewInstitution() {
        return this.userService.createNewInstitution();
    }

    @ngAsync()
    public async createNewSoftware() {
        return this.userService.createNewSoftware();
    }

    @ngAsync()
    public async createNewFamily() {
        return this.userService.createNewFamily();
    }

    @ngAsync()
    public async createNewRelation() {
        return this.userService.createNewRelation();
    }
}
